import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AmplitudeEventService, FeatureFlagService, ProviderSettingsService, StorageManagerService } from '@core/services';
import { environment } from '@environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrl: './base-layout.component.scss',
})
export class BaseLayoutComponent implements OnInit {
  destroyRef = inject(DestroyRef);

  showCookieDialog: boolean = false;

  constructor(
    private storageManagerService: StorageManagerService,
    private providerSettingsService: ProviderSettingsService,
    private featureFlagService: FeatureFlagService,
    private titleService: Title,
    private amplitudeEventService: AmplitudeEventService,
  ) {}

  ngOnInit() {
    this.providerSettingsService.providerSettings.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: async (providerSettings) => {
        if (providerSettings) {
          if (!providerSettings.website_title || providerSettings.website_title === '') {
            this.titleService.setTitle(environment.website_title ?? 'Arivo Serviceportal');
          } else {
            this.titleService.setTitle(providerSettings.website_title);
          }
          document.querySelector('#dynamic-favicon')?.setAttribute('href', providerSettings.images.favicon?.url ?? '/favicon.ico');
          if (this.featureFlagService.getFeatureFlag('enable_cookie_consent') && !this.storageManagerService.load('cookiePreferences')) {
            if (!this.showCookieDialog) {
              this.showCookieDialog = true;
            }
          }
          await this.amplitudeEventService.initializeAmplitude();
        }
      },
    });
  }

  rejectNonEssentialCookies() {
    const cookiePreferences = {
      functionalCookies: false,
    };
    this.storageManagerService.store('cookiePreferences', cookiePreferences);

    this.showCookieDialog = false;
  }

  async acceptAllCookies() {
    const cookiePreferences = {
      functionalCookies: true,
    };
    this.storageManagerService.store('cookiePreferences', cookiePreferences);

    this.showCookieDialog = false;

    if (cookiePreferences.functionalCookies) {
      await this.amplitudeEventService.initializeAmplitude();
    }
  }
}
